import { agentsApi } from '../../../data/agentsApi';
import type { StartEvaSchedulerPassResponse } from './evaCaseViews';

/**
 * "Run scheduler pass now" (spec 045 US5) — injected into the single Agents base api since the
 * route is `agents/{agentKey}/scheduler:start`, not a Verifications read. No cache tags: the
 * scheduler pass is async (it admits due cases in the background), so there is nothing here to
 * invalidate — the dashboard picks up newly-admitted cases on its normal `EvaCase` refetch.
 */
const evaSchedulerEndpoints = agentsApi.injectEndpoints({
  endpoints: (builder) => ({
    startEvaSchedulerPass: builder.mutation<StartEvaSchedulerPassResponse, { agentKey: string }>({
      query: ({ agentKey }) => ({
        url: `/agents/${agentKey}/scheduler:start`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useStartEvaSchedulerPassMutation } = evaSchedulerEndpoints;
